module.exports = __webpack_public_path__ + "static/media/blog.2f32a807.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog.jpeg
// module id = 860
// module chunks = 0